import { useState, useEffect, useCallback } from 'react';
import { useAccountMetaQuery } from '../queries';
import { authService } from '../services/auth-service';

export const useCustomAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(
    authService.getAuthState(),
  );
  const [isLoading, _setIsLoading] = useState<boolean>(false);
  const { data: accountMeta } = useAccountMetaQuery();

  const checkCustomAuth = useCallback(() => {
    return authService.getAuthState();
  }, []);

  const setCustomAuth = useCallback((auth: boolean) => {
    authService.setAuthState(auth);
    setIsAuthenticated(auth);
  }, []);

  const clearCustomAuth = useCallback(() => {
    authService.clearAuth();
    setIsAuthenticated(false);
  }, []);

  useEffect(() => {
    setIsAuthenticated(authService.getAuthState());

    const unsubscribe = authService.subscribe((newAuthState) => {
      setIsAuthenticated(newAuthState);
    });

    return unsubscribe;
  }, []);

  return {
    isAuthenticated,
    isLoading,
    accountMeta,
    setCustomAuth,
    clearCustomAuth,
    checkCustomAuth,
  };
};
